/**
 * Loan Enums
 */

export enum LoanPurpose {
  Purchase = 'Purchase',
  RefinanceRateAndTerm = 'RefinanceRateAndTerm',
  RefinanceCashOut = 'RefinanceCashOut',
  RefinanceNoCashOut = 'RefinanceNoCashOut',
  RefinanceLimitedCashOut = 'RefinanceLimitedCashOut',
  Construction = 'Construction',
  ConstructionToPermanent = 'ConstructionToPermanent',
  HomeImprovement = 'HomeImprovement',
  Other = 'Other',
}

export enum LoanType {
  Conventional = 'Conventional',
  FHA = 'FHA',
  VA = 'VA',
  USDA = 'USDA',
  Jumbo = 'Jumbo',
  SuperJumbo = 'SuperJumbo',
  NonQM = 'NonQM',
  ReverseMortgage = 'ReverseMortgage',
  PortfolioProduct = 'PortfolioProduct',
  HELOCFirstLien = 'HELOCFirstLien',
  HELOCSecondLien = 'HELOCSecondLien',
}

export enum AmortizationType {
  Fixed = 'Fixed',
  AdjustableRate = 'AdjustableRate',
  GraduatedPaymentMortgage = 'GraduatedPaymentMortgage',
  GrowingEquityMortgage = 'GrowingEquityMortgage',
  InterestOnly = 'InterestOnly',
  Balloon = 'Balloon',
  NegativeAmortization = 'NegativeAmortization',
  Step = 'Step',
  BuydownTemporary = 'BuydownTemporary',
  BuydownPermanent = 'BuydownPermanent',
}

export enum AmortizationTypeSimple {
  FixedRate = 'FixedRate',
  GEM = 'GEM',
  GPM = 'GPM',
  ARM = 'ARM',
}

export enum ARMIndexType {
  SOFR = 'SOFR',
  LIBOR = 'LIBOR',
  CMT = 'CMT',
  COFI = 'COFI',
  Prime = 'Prime',
  MTA = 'MTA',
  CD = 'CD',
}

export enum LienPriority {
  First = 'First',
  Second = 'Second',
  Third = 'Third',
  HELOC = 'HELOC',
}

export enum LoanStatus {
  Application = 'Application',
  Processing = 'Processing',
  Submitted = 'Submitted',
  Underwriting = 'Underwriting',
  ConditionalApproval = 'ConditionalApproval',
  Approved = 'Approved',
  ClearToClose = 'ClearToClose',
  ClosingScheduled = 'ClosingScheduled',
  Docs = 'Docs',
  Funding = 'Funding',
  Funded = 'Funded',
  Purchased = 'Purchased',
  Denied = 'Denied',
  Withdrawn = 'Withdrawn',
  Cancelled = 'Cancelled',
  Suspended = 'Suspended',
}

export enum LoanChannel {
  Retail = 'Retail',
  Wholesale = 'Wholesale',
  Correspondent = 'Correspondent',
  ConsumerDirect = 'ConsumerDirect',
  BrokerDirect = 'BrokerDirect',
}

export enum QMType {
  GeneralQM = 'GeneralQM',
  SmallCreditorQM = 'SmallCreditorQM',
  BalloonPaymentQM = 'BalloonPaymentQM',
  SeasonedQM = 'SeasonedQM',
  TemporaryGSEQM = 'TemporaryGSEQM',
  NonQM = 'NonQM',
}

export enum MortgageType {
  Conventional = 'Conventional',
  FHA = 'FHA',
  VA = 'VA',
  USDA = 'USDA',
}
